import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
// 地图选点和经纬度同时存在的情况，会因为行政区划不一致导致问题，因此去掉行政区划
// import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
import dayjs from 'dayjs';
export default {
  name: 'groupbuy_company',
  data: function data() {
    return {
      dayjs: dayjs,
      currentUser: localStorage.getItem('userId'),
      pageConfig: {
        editPageName: '活动方',
        modifyFunName: 'groupBuyCompanyModify',
        delFunName: 'groupBuyCompanyDel',
        queryFunName: 'groupBuyCompanyQueryJoinUser',
        detailFunName: 'groupBuyCompanyDetail',
        addRefundPower: 'groupBuyCompanyAddRefundPower',
        removeRefundPower: 'groupBuyCompanyRefundRefundPower',
        disableFunName: 'mngUserDisable',
        unDisableFunName: 'mngUserUnDisable',
        unLockFunName: 'mngUserUnLock',
        clearAuthFunName: 'mngUserClearAuth'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time'
      },
      formData: {
        id: null,
        userId: null,
        name: null,
        logo: null,
        contact: null,
        contactPhone: null,
        vipState: null,
        vipStartDate: null,
        vipEndDate: null,
        vipCost: null,
        video: null,
        images: null
        // 地图选点和经纬度同时存在的情况，会因为行政区划不一致导致问题，因此去掉行政区划
        // , province: null
        // , city: null
        // , area: null
        // , lbs: []
        ,
        detailAddress: '',
        lon: null,
        lat: null,
        remark: null,
        refundPower: null,
        userAccount: null,
        userNickname: null,
        userPhone: null,
        userEmail: null,
        userCategory: null,
        userState: null
      }
      // 地图配置
      ,
      mapConfig: {
        zoom: 12,
        center: [120.384599, 36.062687],
        activeIndex: '',
        addressList: []
      },
      rules: {
        name: [{
          required: true,
          message: '标题不能为空',
          trigger: 'blur'
        }]
        // 地图选点和经纬度同时存在的情况，会因为行政区划不一致导致问题，因此去掉行政区划
        // , lbs: [
        //   { required: true, message: '行政区划不能为空', trigger: 'blur' }
        // ]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {}
      // 地图选点和经纬度同时存在的情况，会因为行政区划不一致导致问题，因此去掉行政区划
      // , citys: regionData
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  methods: {
    beforeCommand: function beforeCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command
      };
    },
    moreButton: function moreButton(command) {
      switch (command.command) {
        case 'store':
          this.goChild(command.row, 'companyStores');
          break;
        case 'refundPower':
          this.refundPower(command.row.id);
          break;
        case 'unRefundPower':
          this.unRefundPower(command.row.id);
          break;
        case 'unLock':
          this.unLock(command.row.userId);
          break;
        case 'disable':
          this.disableUser(command.row.userId);
          break;
        case 'unDisable':
          this.unDisableUser(command.row.userId);
          break;
        case 'clear':
          this.clearUser(command.row.userId);
          break;
      }
    },
    goChild: function goChild(company, tableName) {
      this.$emit('child-go', company, tableName);
    },
    refundPower: function refundPower(id) {
      var _this = this;
      this.$confirm('确定 “授权” 活动方退款吗').then(function () {
        _this.$api[_this.pageConfig.addRefundPower](id).then(function (res) {
          if (res.data) {
            _this.$message.success('授权成功');
            _this.query();
          } else {
            _this.$message.error('授权失败');
          }
        });
      });
    },
    unRefundPower: function unRefundPower(id) {
      var _this2 = this;
      this.$confirm('确定 “释权” 活动方退款吗').then(function () {
        _this2.$api[_this2.pageConfig.removeRefundPower](id).then(function (res) {
          if (res.data) {
            _this2.$message.success('释权成功');
            _this2.query();
          } else {
            _this2.$message.error('释权失败');
          }
        });
      });
    },
    unLock: function unLock(id) {
      var _this3 = this;
      this.$confirm('确定解锁当前活动方吗').then(function () {
        _this3.$api[_this3.pageConfig.unLockFunName](id).then(function (res) {
          if (res.data) {
            _this3.$message.success('解锁成功');
            _this3.query();
          } else {
            _this3.$message.error('解锁失败');
          }
        });
      });
    },
    disableUser: function disableUser(id) {
      var _this4 = this;
      this.$confirm('确定封禁当前活动方吗').then(function () {
        _this4.$api[_this4.pageConfig.disableFunName](id).then(function (res) {
          if (res.data) {
            _this4.$message.success('封禁成功');
            _this4.query();
          } else {
            _this4.$message.error('封禁失败');
          }
        });
      });
    },
    unDisableUser: function unDisableUser(id) {
      var _this5 = this;
      this.$confirm('确定解禁当前活动方吗').then(function () {
        _this5.$api[_this5.pageConfig.unDisableFunName](id).then(function (res) {
          if (res.data) {
            _this5.$message.success('解禁成功');
            _this5.query();
          } else {
            _this5.$message.error('解禁失败');
          }
        });
      });
    },
    clearUser: function clearUser(id) {
      var _this6 = this;
      this.$confirm('确定清除活动方吗？活动方清除后将不能恢复').then(function () {
        _this6.$confirm('请再次确认，是否清除当前活动方？').then(function () {
          _this6.$confirm('请谨慎操作！！！最后确认是否清除当前活动方？').then(function () {
            _this6.$api[_this6.pageConfig.clearAuthFunName](id).then(function (res) {
              if (res.data) {
                _this6.$message.success('清除成功');
                _this6.query();
              } else {
                _this6.$message.error('清除失败');
              }
            });
          });
        });
      });
    },
    initMapByInput: function initMapByInput(clear) {
      var that = this;

      // 自动搜索插件
      AMap.plugin('AMap.Autocomplete', function () {
        var autoOptions = {
          city: '全国'
        };

        // 创建搜索范围
        var autoComplete = new AMap.Autocomplete(autoOptions);

        // 指定入参
        autoComplete.search(that.formData.detailAddress, function (status, e) {
          if (status === 'complete' && e.info === 'OK') {
            if (e.tips && e.tips.length > 0) {
              var tips = e.tips.filter(function (i) {
                return i.location && i.address.length > 0;
              });
              var tip = tips[0];
              if (typeof tip !== 'undefined') {
                that.mapConfig.center = [tip.location.lng, tip.location.lat];
              }
              that.mapConfig.addressList = tips;
            } else {
              that.mapConfig.addressList = [];
            }
          }
        });
      });
    },
    itemChange: function itemChange(n, index) {
      this.mapConfig.activeIndex = index;

      // 输入后搜索出来的，反地理编码出来的参数有所不同
      var lng = n.lng || n.longitude || n.location.lng;
      var lat = n.lat || n.latitude || n.location.lat;
      this.formData.detailAddress = (n.district || '') + ' ' + (n.name || '');
      this.formData.lon = lng;
      this.formData.lat = lat;
      this.mapConfig.zoom = 13;
      this.mapConfig.center = [lng, lat];
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));

      // 地图选点和经纬度同时存在的情况，会因为行政区划不一致导致问题，因此去掉行政区划
      // if (typeof (paramData.province) !== 'undefined' && typeof (paramData.city) !== 'undefined' && (paramData.area) !== 'undefined') {
      //  paramData.lbs = [TextToCode[paramData.province].code, TextToCode[paramData.province][paramData.city].code, TextToCode[paramData.province][paramData.city][paramData.area].code]
      // } else {
      //   paramData.lbs = []
      // }

      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    } // TODO: 方法 - 前端 > 后端 数据差异
    ,
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));

      // 地图选点和经纬度同时存在的情况，会因为行政区划不一致导致问题，因此去掉行政区划
      // if (this.formData.lbs.length > 0) {
      //   saveFormData.province = CodeToText[this.formData.lbs[0]]
      //   saveFormData.city = CodeToText[this.formData.lbs[1]]
      //   saveFormData.area = CodeToText[this.formData.lbs[2]]
      // }

      return saveFormData;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    upload: function upload(_ref) {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this7.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this7.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this7.formData.logo = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    previewFile: function previewFile() {
      window.open(this.formData.logo);
    },
    removeFile: function removeFile() {
      this.formData.logo = '';
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(rowData) {
      var _this8 = this;
      this.$api[this.pageConfig.detailFunName](rowData.id).then(function (res) {
        _this8.initFormData(res.data);
        _this8.formData.userAccount = rowData.userAccount;
        _this8.formData.userNickname = rowData.userNickname;
        _this8.formData.userPhone = rowData.userPhone;
        _this8.formData.userEmail = rowData.userEmail;
        _this8.formData.userCategory = rowData.userCategory;
        _this8.formData.userState = rowData.userState;
        _this8.editDialogTitle = _this8.pageConfig.editPageName + '维护';
        _this8.editDialogShow = true;
      });
    },
    del: function del(id) {
      var _this9 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this9.$api[_this9.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this9.$message.success('删除成功');
            _this9.query();
          } else {
            _this9.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this10 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this10.tableData = res.data || [];
        _this10.totalCount = res.count;
        _this10.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this11 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          _this11.$api[_this11.pageConfig.modifyFunName](_this11.saveFormDataProcess(_this11.formData)).then(function (res) {
            if (res.data) {
              _this11.$message.success('编辑成功');
              _this11.initFormData(_this11.emptyFormData);
              _this11.editDialogShow = false;
              _this11.query();
            } else {
              _this11.$message.error('编辑失败');
            }
          });
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};